import { render, staticRenderFns } from "./default-value.vue?vue&type=template&id=eff58044&scoped=true&"
import script from "./default-value.vue?vue&type=script&lang=js&"
export * from "./default-value.vue?vue&type=script&lang=js&"
import style0 from "./default-value.vue?vue&type=style&index=0&id=eff58044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff58044",
  null
  
)

export default component.exports